import { reactive } from 'vue';

/** Estado mínimo para abrir el panel SNAT unificado desde cualquier componente (p. ej. barra superior). */
export const snatUnifiedToolsBus = reactive({
  expandRequestId: 0,
  /** 'errors' | 'requirements' */
  tab: 'errors',
});

/**
 * Abre el panel (o lo reenfoca) y selecciona la pestaña indicada.
 * @param {'errors' | 'requirements'} [tab]
 */
export function openSnatUnifiedTools(tab = 'errors') {
  snatUnifiedToolsBus.tab = tab === 'requirements' ? 'requirements' : 'errors';
  snatUnifiedToolsBus.expandRequestId += 1;
}
